import { Component } from '@theme/component';

/**
 * A button component that acts as a proxy to click the ingredients thumbnail
 * in the product media gallery slideshow.
 *
 * @extends {Component}
 */
class WhatsInsideButton extends Component {
  /**
   * Handles the click event by finding and clicking the ingredients thumbnail.
   *
   * @param {Event} event - The click event
   */
  handleClick(event) {
    event.preventDefault();

    const scrollTarget = (this.dataset.scrollTarget || '').trim();
    if (scrollTarget.startsWith('#')) {
      const targetId = scrollTarget.slice(1);
      const targetEl = targetId ? document.getElementById(targetId) : null;

      if (targetEl instanceof HTMLElement) {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    const ingredientsButton = document.querySelector('.slideshow-controls__ingredients');

    if (ingredientsButton instanceof HTMLElement) {
      ingredientsButton.click();

      // Scroll the gallery into view smoothly
      const gallery = ingredientsButton.closest('slideshow-component');
      if (gallery) {
        gallery.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }
}

if (!customElements.get('whats-inside-button')) {
  customElements.define('whats-inside-button', WhatsInsideButton);
}
